import { render } from "./ViewMoreInstitute.vue?vue&type=template&id=5441770d"
import script from "./ViewMoreInstitute.vue?vue&type=script&lang=js"
export * from "./ViewMoreInstitute.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__